// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2ge7A","inputWrap":"CustomTip_inputWrap__2Tl2M"};